import * as React from "react";
import { FileOutlined, MailOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";

type Props = {
    fileName: string;
};

const AttachmentIcon: React.FC<Props> = ({ fileName }) => {
    if (!fileName) {
        return <FileOutlined className="attachment-icon" />;
    }

    const extension = fileName.split(".").pop();

    switch (extension) {
        case "pdf":
            return <i className={`alpha-icon attachment-icon doc-pdf`} />;
        case "xls":
        case "xlsx":
        case "xltm":
        case "xlsm":
            return <i className={`alpha-icon attachment-icon doc-xls`} />;
        case "doc":
        case "docx":
            return <i className={`alpha-icon attachment-icon doc-word`} />;
        case "msg":
            return <MailOutlined className="attachment-icon" />;
        default:
            return <FileOutlined className="attachment-icon" />;
    }
};

export default observer(AttachmentIcon);
